import { BASE_LAYOUT_VERSION, BaseLayoutConfig } from '../types/base-layout'

export const DEFAULT_BASE_LAYOUT_CONFIG: BaseLayoutConfig = {
  version: BASE_LAYOUT_VERSION,
  tabs: [
    {
      id: 'tab1',
      label: 'Tab 1',
      sections: [
        { id: 'tab1-textbox1', type: 'textBox', options: { field: 'textBox1' }, content: '' },
        { id: 'tab1-textbox2', type: 'textBox', options: { field: 'textBox2' }, content: '' },
        { id: 'tab1-textbox3', type: 'textBox', options: { field: 'textBox3' }, content: '' },
        { id: 'tab1-textbox4', type: 'textBox', options: { field: 'textBox4' }, content: '' },
        { id: 'tab1-daily', type: 'dailyMessage', title: 'Daily Messages', options: { days: {} } },
        { id: 'tab1-photos', type: 'basePhotos', title: 'Photos', options: { limit: 6 } },
      ],
    },
    {
      id: 'tab2',
      label: 'Tab 2',
      sections: [
        { id: 'tab2-textbox5', type: 'textBox', options: { field: 'textBox5' }, content: '' },
        { id: 'tab2-textbox6', type: 'textBox', options: { field: 'textBox6' }, content: '' },
        { id: 'tab2-textbox7', type: 'textBox', options: { field: 'textBox7' }, content: '' },
        { id: 'tab2-textbox8', type: 'textBox', options: { field: 'textBox8' }, content: '' },
        { id: 'tab2-mission', type: 'missionStories', title: 'Mission Stories', options: { limit: 5 } },
      ],
    },
  ],
}

